<img
  [ngSrc]='logoUrl'
  alt='Logo'
  class='logo-img me-3'
  width='70'
  height='70'
  [routerLink]="['/']" role='button'
/>
<a class='navbar-brand title'>
  <h2 class='h3 fw-bold mb-1'>{{ logoText }}</h2>
</a>
